<template>
  <CustomButton
    v-if="isLoyaltyEnabled && isMobile"
    :disabled="
      !isLoginEnabled ||
      (!applicationSetup.loyalty.status && !applicationSetup.login) ||
      paymentFailed
    "
    :label="
      userProfile.isAuthenticated
        ? $t('general.signOut')
        : $t('loyaltyButtonLabel')
    "
    @click="makeLoginVisible"
    class="mb-2 h-8 w-full rounded-none px-6"
    spanClass="gc-font-small-title max-w-[280px] truncate" />

  <CustomDrawer
    v-model="isLoginVisible"
    :position="isMobile ? 'bottom' : 'right'"
    :width="isMobile ? 'w-full' : 'w-[35%]'"
    height="h-auto"
    @update:modelValue="onDrawerClose">
    <template #drawerContent>
      <Login
        @close="closeLoginDrawer"
        @showLoggedInModal="onShowLoggedInModal"
        @showLoggedOutModal="onShowLoggedOutModal"
        @showSignupModal="onShowSignUpModal"
        @isSignInEmptyOrValid="handleSignInValidation"
        @isSignUpEmptyOrValid="handleSignUpValidation"></Login>
    </template>
  </CustomDrawer>

  <InformativeModal
    :isVisible="showLoggedInModal"
    :title="$t('general.login')"
    :description="$t('general.loginSuccess')"
    :buttonText="$t('general.closeButtonText')"
    type="success"
    @update:isVisible="showLoggedInModal = false" />
  <InformativeModal
    :isVisible="showLoggedOutModal"
    :title="$t('general.signOut')"
    :description="$t('general.logoutSuccess')"
    :buttonText="$t('general.closeButtonText')"
    type="success"
    @update:isVisible="showLoggedOutModal = false" />
  <InformativeModal
    :isVisible="showSignUpModal"
    :title="$t('general.emailSentTitle')"
    :description="$t('general.emailSentDescription')"
    :buttonText="$t('general.closeButtonText')"
    type="success"
    @update:isVisible="showSignUpModal = false" />
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';

import { useScreenSize } from '@composables/useScreenSize';
import { useAppConfigStore } from '@stores/appConfig.store';
import { useUserProfile } from '@stores/userProfile.store';
import router from '@/router';

import CustomDrawer from '../customComponents/CustomDrawer.vue';
import CustomButton from '@/components/customComponents/CustomButton.vue';
import InformativeModal from '@/components/customComponents/InformativeModal.vue';
import Login from '@/components/Login/LoginMain.vue';

const route = useRoute();
const { isMobile } = useScreenSize();

const appConfigStore = useAppConfigStore();
const { applicationSetup } = storeToRefs(appConfigStore);

const userProfileStore = useUserProfile();
const { userProfile } = storeToRefs(userProfileStore);

const isLoginVisible = ref(false);
const showLoggedInModal = ref(false);
const showLoggedOutModal = ref(false);
const showSignUpModal = ref(false);

const isSignInEmptyOrValid = ref(true);
const isSignUpEmptyOrValid = ref(true);

const isLoyaltyEnabled = computed(() => {
  return (
    applicationSetup.value &&
    applicationSetup.value.loyalty &&
    applicationSetup.value.loyalty.status === true
  );
});

const isLoginEnabled = computed(() => {
  if (
    router.currentRoute.value.path === '/payment' ||
    router.currentRoute.value.path === '/confirmation' ||
    router.currentRoute.value.path === '/payment/mbway'
  ) {
    return false;
  }
  return true;
});

const paymentFailed = computed(() => {
  return parseInt(route.query.paymentFailed) ? true : false;
});

const makeLoginVisible = () => {
  isLoginVisible.value = true;
};

const closeLoginDrawer = () => {
  isLoginVisible.value = false;
};

const onShowLoggedInModal = () => {
  showLoggedInModal.value = true;
  closeLoginDrawer();
};

const onShowLoggedOutModal = () => {
  showLoggedOutModal.value = true;
  closeLoginDrawer();
};

const onShowSignUpModal = () => {
  showSignUpModal.value = true;
  closeLoginDrawer();
};

const handleSignInValidation = (value) => {
  isSignInEmptyOrValid.value = value;
};

const handleSignUpValidation = (value) => {
  isSignUpEmptyOrValid.value = value;
};

const onDrawerClose = () => {
  const isSignUpVisible = document.querySelector('.signUpButton');
  const isSignUp = !!isSignUpVisible;

  const isValid = isSignUp
    ? isSignUpEmptyOrValid.value
    : isSignInEmptyOrValid.value;
  const elementToCheck = isSignUp ? '.signUpButton' : '.signInButton';

  if (!isValid) {
    document.querySelector(elementToCheck).click();
    isLoginVisible.value = true;
  } else {
    isLoginVisible.value = false;
  }
};
</script>
